module.exports = __webpack_public_path__ + "img/jelly_thumb.565df537.jpg";